import angular from 'angular';
import Lexica from '../constants/lexica';
import CurrentUser from '../models/user';

function LexiconFilter(Lexica, CurrentUser) {
	return function (key = 'dialect', plural, textCase) {
		let lexicon = CurrentUser.data.lexicon || 'legal'; // debug with media fallback
		var str = `${Lexica[lexicon][key] || key}${plural ? 's' : ''}`;
		if (textCase === 'upper') {
			str = str.toUpperCase();
		} else if (textCase === 'lower') {
			str = str.toLowerCase();
		}
		return str;
	};
}
LexiconFilter.$inject = ['Lexica', 'CurrentUser'];

export default angular.module('filters.lexicon', [Lexica, CurrentUser])
	.filter('lexicon', LexiconFilter)
	.name;



// WEBPACK FOOTER //
// ./project/filters/lexicon.js